import type * as React from 'react'

import { cn } from '@nwwp/ui-shadcn/lib/utils'

type IconTileProps = {
  label: string
  icon: React.ReactNode
  /** `stack` = icon above label. `row` = icon left of label. */
  layout?: 'stack' | 'row'
  className?: string
}

/** Shared icon + label tile used by feature grids. */
function IconTile({ label, icon, layout = 'stack', className }: IconTileProps) {
  const isRow = layout === 'row'

  return (
    <div
      className={cn(
        'flex h-full rounded-xl border border-border bg-card shadow-sm',
        isRow ? 'flex-row items-center gap-3 px-4 py-3 text-left' : 'flex-col items-center gap-2 px-3 py-4 text-center',
        className
      )}
    >
      <span className="flex shrink-0 text-primary" aria-hidden>
        {icon}
      </span>
      <span className={cn('text-body-sm-bold text-foreground', !isRow && 'text-center')}>{label}</span>
    </div>
  )
}

export { IconTile }
export type { IconTileProps }
